import React, { useEffect, useState } from "react";
import { Skeleton } from "antd";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { RootState } from "../../../../../store/store";
import { useSelector } from "react-redux";
import {
  getCurriculum,
  getCurriculumAssignmentForStudent,
} from "../../../../../api/curriculum/curriculum";
import { openNotificationWithIcon } from "../../../../../utils/helper";
import Lessongroup from "../lessongroup/lessongroup";
import useRewards from "../../../../../customhooks/rewards/useRewards";

const Studentlesson = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const { curriculumId } = useParams();
  const { loadingRewards, rewards } = useRewards();

  // eslint-disable-next-line
  let [searchParams, setSearchParams] = useSearchParams();
  const curriculumAssignmentId = searchParams.get("curriculumAssignmentId");

  const [completedIds, setCompletedIds] = useState([]);
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line
  const [curriculum, setCurriculum] = useState<any>({});
  const [data, setData] = useState<any[]>([]);

  const state = useSelector((state: RootState) => ({
    user: state.user.user,
  }));

  // eslint-disable-next-line
  const { user } = state;

  useEffect(() => {
    navigate(`${pathname}${search}`, {
      state: {
        pageName: "Lesson",
      },
    });

    // eslint-disable-next-line
  }, []);

  const fetchCurriculumAssignment = async () => {
    try {
      setLoading(true);
      const res = await getCurriculumAssignmentForStudent(
        curriculumAssignmentId || ""
      );
      const { data } = res?.data;
      setCompletedIds(data?.progressId?.completedUnits || []);
      setLoading(false);
    } catch (error: any) {}
  };


  useEffect(() => {
    if (
      curriculumAssignmentId !== undefined &&
      curriculumAssignmentId !== null &&
      curriculumAssignmentId.length > 0
    ) {
      fetchCurriculumAssignment();
    }
    // eslint-disable-next-line
  }, [curriculumAssignmentId]);

  const fetchCurriculum = async () => {
    try {
      setLoading(true);
      const res = await getCurriculum(curriculumId || "");
      const { data } = res?.data;
      setCurriculum(data);
      const newData: any[] = [];
      data.modules.forEach((item: any, index: number) => {
        let obj = {
          ...item,
          open: index === 0 ? true : false,
        };
        newData.push(obj);
      });
      setData(newData);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      if (error?.response) {
        openNotificationWithIcon(
          "error",
          "Get Curriculum",
          `${error?.response?.data?.message || "Something went wrong"}`
        );
      } else {
        openNotificationWithIcon(
          "error",
          "Get Curriculum",
          "Something went wrong"
        );
      }
      navigate(`/student/dashboard/lessons`);
    }
  };

  useEffect(() => {
    fetchCurriculum();

    // eslint-disable-next-line
  }, []);

  const openLevel = (levelIndex: number, value: boolean) => {
    let updatedLevels: any = [...data];
    let newLevels = updatedLevels.map((item: any, index: number) => {
      if (index === levelIndex) {
        return {
          ...item,
          open: value,
        };
      }

      return {
        ...item,
        open: false,
      };
    });

    setData(newLevels);
  };

  return (
    <div className="mb-20 mt-4 h-screen pb-20 pr-10">
      {loading ? (
        <>
          {[1, 2, 3, 4, 5].map((item) => (
            <div key={`loading-modules-${item}`}>
              <Skeleton.Button
                active={true}
                size={"large"}
                shape={"square"}
                block={true}
                style={{
                  height: "15rem",
                  marginBottom: "1rem",
                  borderRadius: "1rem",
                  marginRight: "1rem",
                  width: "100%",
                }}
              />
            </div>
          ))}
        </>
      ) : (
        <div className="max-h-screen min-h-full overflow-x-hidden overflow-y-auto ">
          {data
            .sort((a, b) => a.order - b.order)
            .map((item: any, index: number) => (
              <Lessongroup
                key={item?._id}
                details={item}
                index={index}
                openLevel={openLevel}
                completedIds={completedIds}
                curriculumAssignmentId={curriculumAssignmentId || ""}
                loadingRewards={loadingRewards}
                rewards={rewards}
              />
            ))}
        </div>
      )}
    </div>
  );
};

export default Studentlesson;
